import { useEffect } from 'react';
import Loader from '../../components/Loader/Loader';

const LoaderModal = () => {
  useEffect(() => {
    // Force scroll blocking by setting the body's overflow to hidden
    document.body.style.overflow = 'hidden';

    // Cleanup: Reset overflow when the modal is unmounted
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <>
      <div className="modal-overlay justify-center items-center flex fixed inset-0 z-50 outline-none focus:outline-none backdrop-blur-sm bg-opacity-25">
        <div className="relative w-auto mx-auto max-w-3xl">
          <div className="relative font-inter antialiased">
            <main className="relative min-h-screen flex flex-col justify-center overflow-hidden">
              <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-24">
                <div className="flex justify-center">
                  <div className="max-w-7xl mx-auto text-center bg-white text-black px-4 sm:px-8 rounded-xl shadow">
                    <Loader />
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
      <div className="opacity-45 backdrop-blur-3xl fixed inset-0 z-40 bg-black"></div>
    </>
  );
};

export default LoaderModal;
